class ProductBadge extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.tags = this.element.dataset.tags.split(",");
    this.isPDP = this.element.dataset.pdp !== undefined;

    if (this.multiBadge.length) this.createBadges();
    else if (this.badge) {
      this.createBadge();
    }
    // if (this.badge) this.createBadge();
  }

  createBadges() {
    this.multiBadge.forEach((badge, index) => {
      
      if (index > 1) return;

      console.log('CREATE BADGE:', badge.title, badge)
      this.element.innerHTML += `
        <div class="product-badge" style="background-color: ${
          badge.backgroundColor
        }; color: ${badge.textColor}; --positional: ${index * 22 + 13.5}px">
            ${badge.title}
        </div>
    `;
    });
  }

  createBadge() {
    this.element.innerHTML = `
        <div class="product-badge" style="background-color: ${this.badge.backgroundColor}; color: ${this.badge.textColor};">
            ${this.badge.title}
        </div>
    `;
  }

  // return the badge applicable to this product
  get badge() {
    return this.badges.find((badge) =>
      this.isPDP
        ? badge.pdp_enabled && this.tags.includes(badge.tag)
        : this.tags.includes(badge.tag)
    );
  }

  get multiBadge() {
    return this.badges.filter((badge) =>
      this.isPDP
        ? badge.pdp_enabled && this.tags.includes(badge.tag)
        : this.tags.includes(badge.tag)
    );
  }

  // all badges from the product-badges sections
  get badges() {
    try {
      return JSON.parse(
        document.querySelector("script[data-badges-source]").innerHTML
      );
    } catch (error) {
      return [];
    }
  }
}

customElements.define("product-badge", ProductBadge);
